import * as React from 'react'
import { useParams } from 'react-router-dom';
import { AsyncButton, Button, DropDownButton, ToggleFilter, useAlert } from 'uxp/components';
import { IDefaultUIProps } from '../..';
import { findCardTemplate } from '../common/common';
import Designer, { IDesignerInstanceProps, IDesignerMode } from './Designer';
import Layout from './Layout';
import { hasValue, loadScriptFileAsync } from '../../util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WidgetDesignerThemeChanger from './WidgetDesignerThemeChanger';

interface IEditWidgetProps extends IDefaultUIProps {

}

const EditWidget: React.FunctionComponent<IEditWidgetProps> = props => {
    const { uxpContext } = props

    const { id } = useParams<{ id: string }>()

    const [widget, setWidget] = React.useState(null)
    const [template, setTemplate] = React.useState(null)
    const [mode, setMode] = React.useState<IDesignerMode>('design')
    const [canSave, setCanSave] = React.useState(false)
    const [hasModified, setHasModified] = React.useState(false)
    let [closePopup, setClosePopup] = React.useState(false)

    // just to force render
    const [counter, setCounter] = React.useState(0)
    const alerts = useAlert()
    const designerRef: React.MutableRefObject<IDesignerInstanceProps> = React.useRef(null)

    React.useEffect(() => {
        if (!id) {
            return
        }
        // get card details 
        props.uxpContext.executeService('UXP', 'CardTemplate:Details', { Key: id }, { json: true })
            .then(async res => {
                let _widget = res[0]
                if (_widget) {
                    let t = _widget.Template
                    let Template: any = {}
                    try {
                        Template = JSON.parse(t)
                    } catch (error) {
                        console.log('unable to parse template ');
                    }

                    if (Template.__template__) {
                        setTemplate(Template.__template__.type)
                    }

                    setWidget({ ..._widget, Template })

                    const parts = _widget.WidgetID.split("/")
                    const moduleId = parts[0]
                    if (hasValue(moduleId)) {
                        // load script file 
                        if (moduleId == 'uxp-widget-designer-bundle') return
                        await loadScriptFileAsync(`/api/UXP/module?id=${moduleId}`, moduleId)
                        setCounter(prev => prev + 1)
                    }
                }

            })
            .catch(e => {

            })
    }, [id])

    const headerActions = () => {

        return <>

            <Button
                title='Export'
                icon='fas cloud-download'
                onClick={designerRef.current?.export}
                className='uxp-designer-action-btn'
            />

            <Button
                title='Delete'
                icon='fas trash'
                onClick={designerRef.current?.delete}
                className='uxp-designer-action-btn'
            />

            <WidgetDesignerThemeChanger />

            <ToggleFilter
                value={mode as string}
                onChange={s => setMode(s as IDesignerMode)}
                options={[
                    { label: 'Design', value: 'design' },
                    { label: 'Preview', value: 'preview' }
                ]}
                className="lucy-canvas-toggle-button"
            />

            <AsyncButton
                title='Update Widget'
                loadingTitle='Updating Widget...'
                icon='fas save'
                onClick={designerRef.current?.save}
                className='uxp-designer-action-btn save-btn'
                active={canSave}
            />

            <DropDownButton
                content={() => <>

                    <div className="uxp-designer-advanced-action-dropdown-content">
                        <div className="uxp-designer-advanced-action-dropdown-content-section">

                            <div className="uxp-designer-advanced-action-dropdown-content-section-title">Save widget as a Template</div>
                            <div className="uxp-designer-advanced-action-dropdown-content-section-description">This will save the widget as a new Template under "My Templates" and you will be able to use this later as a template to create new widgets</div>
                            <AsyncButton
                                title='Save widget as a template'
                                loadingTitle='Saving...'
                                onClick={() => designerRef.current?.saveAsTemplate().then(res => setClosePopup(true))}
                                active={canSave}
                            />

                        </div>
                    </div>
                </>}
                onClose={() => { setClosePopup(false) }}
                forceClose={closePopup}
            >
                <div className="uxp-designer-advanced-action-dropdown-btn">
                    <FontAwesomeIcon icon={['fas', 'ellipsis-h']} />
                </div>
            </DropDownButton>
        </>
    }

    return <Layout
        uxpContext={uxpContext}
        headerActions={headerActions}
        hasModified={hasModified}
    >

        <Designer
            ref={designerRef}
            mode={mode}
            onChangeMode={setMode}
            isNew={false}
            template={findCardTemplate(template)}
            widget={widget}
            uxpContext={uxpContext}
            modelKey={''}
            initialSource={''}
            enableSave={(val) => { setCanSave(val) }}
            onModifiyContent={(val) => {
                setHasModified(val)
                setCounter(prev => (prev += 1))
            }}
            templateId={template}
        />

    </Layout>
}

export default EditWidget